import { Link } from 'react-router-dom';

export default function StrengthsSection() {
  const mainStrength = {
    title: '公立高校10年の経験を活かした指導',
    description: '公立高校で10年間、進路指導や入試業務に携わってきた経験豊富な講師が在籍。広島県の高校入試制度を熟知し、内申点対策から入試本番まで、的確なアドバイスと指導を提供します。学習塾NICKは廿日市市の中学校の特性も理解しているため、各学校に合わせた定期テスト対策も万全です。',
    image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/3d85a50a8488b2baadd8b877a91925b1.jpeg'
  };

  const additionalStrengths = [
    {
      icon: 'ri-group-line',
      title: '少人数指導と集団講座指導のハイブリッド',
      description: '一人ひとりの理解度に合わせて、少人数クラスと完全個別指導を組み合わせた柔軟な指導スタイル。生徒の性格や学習状況に最適な環境を提供します。'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '徹底した提出物管理',
      description: '内申点に直結する提出物を確実に管理。学校の課題やワークの進捗をチェックし、期限内に質の高い提出物を完成させるサポートを行います。'
    },
    {
      icon: 'ri-book-2-line',
      title: '学校別の定期テスト対策',
      description: '廿日市市内の各中学校の出題傾向を分析。学校ごとの特徴を踏まえた対策で、定期テストでの得点アップを実現します。'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'データに基づく学習計画',
      description: '定期的な学力テストと分析により、一人ひとりの弱点を明確化。科学的なアプローチで効率的な学習計画を立案し、着実な成績向上を目指します。'
    }
  ];

  return (
    <section className="py-24 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#4a90e2]/10 px-6 py-2 rounded-full mb-4">
            <p className="text-sm font-semibold text-[#4a90e2]">廿日市市大野の学習塾NICK</p>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332]">
            廿日市で選ばれている理由
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 lg:order-1">
            <img
              src={mainStrength.image}
              alt="廿日市 塾 経験豊富な講師による指導"
              className="w-full h-[500px] object-cover rounded-3xl shadow-2xl"
            />
          </div>

          <div className="order-1 lg:order-2">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-6 leading-tight">
              {mainStrength.title}
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              {mainStrength.description}
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-3 bg-[#f8f9fa] border-2 border-[#1a2332] text-[#1a2332] px-8 py-4 rounded-full font-semibold hover:bg-[#1a2332] hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              詳しく見る
              <i className="ri-arrow-right-up-line text-xl"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {additionalStrengths.map((strength, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${strength.icon} text-3xl text-[#4a90e2]`}></i>
              </div>
              <h4 className="text-xl font-bold text-[#1a2332] mb-4">
                {strength.title}
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {strength.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-3xl p-10 border border-gray-200">
          <h4 className="text-2xl font-bold text-[#1a2332] mb-6 text-center">
            <strong>大野の学習塾</strong>NICKは廿日市市、阿品、大竹市など周辺地域からも多数通塾
          </h4>
          <p className="text-gray-600 leading-relaxed text-center max-w-4xl mx-auto">
            学習塾NICKは、<strong>廿日市市大野</strong>を中心に、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からも多くの中学生が通っています。地域に根ざした<strong>廿日市の塾</strong>として、各地域の中学校の特性を理解し、きめ細かな指導を行っています。無料体験も随時受付中ですので、お気軽にお問い合わせください。
          </p>
        </div>
      </div>
    </section>
  );
}
